export const pickText = (language, english, italian) => (language === "it" ? italian : english);

export const categoryLabels = {
  en: {
    all: "All",
    sefira: "Sefirot",
    chakra: "Chakras",
    tattva: "Tattvas",
    symbol: "Symbols",
    structure: "Structures",
  },
  it: {
    all: "Tutti",
    sefira: "Sefirot",
    chakra: "Chakra",
    tattva: "Tattva",
    symbol: "Simboli",
    structure: "Strutture",
  },
};

export const navigationLabels = {
  en: [
    { id: "home", to: "/", label: "Home" },
    { id: "atlas", to: "/atlas", label: "Atlas" },
    { id: "archive", to: "/archive", label: "Archive" },
    { id: "timeline", to: "/timeline", label: "Timeline" },
    { id: "structure", to: "/structure", label: "Structure" },
    { id: "glossary", to: "/glossary", label: "Glossary" },
    { id: "vip", to: "/vip-chat", label: "VIP Oracle" },
    { id: "community", to: "/community", label: "Community" },
    { id: "achievements", to: "/achievements", label: "Badges" },
    { id: "leaderboard", to: "/leaderboard", label: "Ranks" },
    { id: "correspondences", to: "/correspondences", label: "Map" },
    { id: "initiation", to: "/initiation", label: "Initiation" },
    { id: "account", to: "/vip-account", label: "Account" },
  ],
  it: [
    { id: "home", to: "/", label: "Ingresso" },
    { id: "atlas", to: "/atlas", label: "Atlante" },
    { id: "archive", to: "/archive", label: "Archivio" },
    { id: "timeline", to: "/timeline", label: "Timeline" },
    { id: "structure", to: "/structure", label: "Struttura" },
    { id: "glossary", to: "/glossary", label: "Glossario" },
    { id: "vip", to: "/vip-chat", label: "Oracolo V.I.P." },
    { id: "community", to: "/community", label: "Comunita" },
    { id: "achievements", to: "/achievements", label: "Badge" },
    { id: "leaderboard", to: "/leaderboard", label: "Classifica" },
    { id: "correspondences", to: "/correspondences", label: "Mappa" },
    { id: "initiation", to: "/initiation", label: "Iniziazione" },
    { id: "account", to: "/vip-account", label: "Account" },
  ],
};

export const regionHints = {
  en: {
    crown: "Crown",
    heart: "Heart",
    throat: "Throat",
    sacral: "Sacral",
    root: "Root",
    feet: "Feet",
    spine: "Spine",
    head: "Head",
    chest: "Chest",
    stomach: "Stomach",
    legs: "Legs",
    foundation: "Foundation",
  },
  it: {
    crown: "Corona",
    heart: "Cuore",
    throat: "Gola",
    sacral: "Sacrale",
    root: "Radice",
    feet: "Piedi",
    spine: "Colonna",
    head: "Testa",
    chest: "Petto",
    stomach: "Stomaco",
    legs: "Gambe",
    foundation: "Fondamento",
  },
};

export const visualPolicyCopy = {
  en: {
    standard: "Displayed as part of the living symbolic atlas.",
    abstract: "Represented abstractly to emphasize function over literal depiction.",
    "text-only": "Presented as text-only for historical context and modern care.",
  },
  it: {
    standard: "Mostrato come parte dell'atlante simbolico vivente.",
    abstract: "Rappresentato in modo astratto per enfatizzare la funzione più della raffigurazione letterale.",
    "text-only": "Presentato solo come testo per contesto storico e attenzione moderna.",
  },
};